module.exports = __webpack_public_path__ + "img/H4.f44d2915.jpg";